import React from 'react'

import T from 'components/FormattedMessage'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import Typography from '@material-ui/core/Typography'

import { AchievementTypeToken } from 'lib/enumTranslations'
import { IAchievement } from 'protos'

import AchievementSummary from './components/AchievementSummary'
import LatestAchievement from './components/LatestAchievement'
import AchievementList from './components/AchievementList'

export interface Props {
  achievementsTotal: number
  achievementsUnlocked: number
  achievements: IAchievement[]
  latestAchievement?: IAchievement | null
}

const AchievementsTab = ({
  achievements,
  latestAchievement,
  achievementsTotal,
  achievementsUnlocked,
}: Props) => (
  <>
    <AchievementSummary
      numTotal={achievementsTotal}
      numUnlocked={achievementsUnlocked}
    />
    {latestAchievement && (
      <>
        <List>
          <ListItem divider>
            <Typography variant="caption">
              <T id="achievements_section_latest" />
            </Typography>
          </ListItem>
        </List>
        <LatestAchievement
          level={latestAchievement.level || 0}
          earnedBonus={latestAchievement.currentLevelBonus}
          title={<T id={AchievementTypeToken(latestAchievement.type!)} />}
        />
      </>
    )}
    <List>
      <ListItem divider>
        <Typography variant="caption">
          <T id="achievements_section_all" />
        </Typography>
      </ListItem>
    </List>
    <AchievementList achievements={achievements} />
  </>
)

export default AchievementsTab
try {
    // @ts-ignore
    AchievementsTab.displayName = "AchievementsTab";
    // @ts-ignore
    AchievementsTab.__docgenInfo = { "description": "", "displayName": "AchievementsTab", "props": { "achievementsTotal": { "defaultValue": null, "description": "", "name": "achievementsTotal", "required": true, "type": { "name": "number" } }, "achievementsUnlocked": { "defaultValue": null, "description": "", "name": "achievementsUnlocked", "required": true, "type": { "name": "number" } }, "achievements": { "defaultValue": null, "description": "", "name": "achievements", "required": true, "type": { "name": "any[]" } }, "latestAchievement": { "defaultValue": null, "description": "", "name": "latestAchievement", "required": false, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/routes/Profile/ProfileScreen/tabs/AchievementsTab/AchievementsTab.tsx#AchievementsTab"] = { docgenInfo: AchievementsTab.__docgenInfo, name: "AchievementsTab", path: "src/routes/Profile/ProfileScreen/tabs/AchievementsTab/AchievementsTab.tsx#AchievementsTab" };
}
catch (__react_docgen_typescript_loader_error) { }